<div class="notFound">
  <div class="container">
    <div class="row">
      <div class="col-12 mt-4">
        <div style="text-align: center;">
          <img [src]="backgroundImage" alt="" [width]="width" [height]="height">
        </div>
      </div>
      <div class="col-12 mt-4 d-flex flex-column align-items-center">
        <span class="description">{{text}}</span>
        <span class="comback">Chúng tôi sẽ trở lại sớm nhất!!!</span>
      </div>
    </div>
  </div>
</div>